import styled from 'styled-components';
import { color, space, font, fontStack, query } from '@design/templateFns';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Button } from '@components/Button';
import { PropertyListingStatusWrapper } from '@components/Card/PropertyListingCard/style';

//
//
// All Images Modal
//
export const GalleryModalContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${color('bg')};
  opacity: 0;
  visibility: hidden;
  z-index: -1;
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;

  &.modal-open {
    opacity: 1;
    visibility: visible;
    z-index: 5000;
  }
`;

export const GalleryModalHeader = styled.div`
  background-color: ${color('bg')};
  box-shadow: 0px 0px 12px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  padding-right: ${space('marginMobile')};
  padding-left: ${space('marginMobile')};

  .swiper {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: visible;
    list-style: none;
    padding: ${space('x7')} 0 0 0;
    /* Fix of Webkit flickering */
    z-index: 1;

    @media screen and (${query.below('tablet')}) {
      padding-top: ${space('x10')};
    }
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;

    @media screen and (${query.atLeast('tablet')}) {
      justify-content: center;
    }
  }
  .swiper-android .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }
  .swiper-pointer-events {
    touch-action: pan-y;
  }
  .swiper-pointer-events.swiper-vertical {
    touch-action: pan-x;
  }
  .swiper-slide {
    flex-shrink: 0;
    width: auto;
    height: 100%;
    position: relative;
    transition-property: transform;
    & + .swiper-slide {
      margin-left: ${space('x7')};

      @media screen and (${query.below('tablet')}) {
        margin-left: ${space('x6')};
      }
    }
  }
  .swiper-slide-invisible-blank {
    visibility: hidden;
  }
`;

export const GalleryModalNavSwiper = styled(Swiper)``;

export const GalleryModalNavButton = styled.button<{ $active: boolean }>`
  ${font('subhead-sm')};
  color: ${({ $active }) => ($active ? color('fg') : color('gray4'))};
  background-color: transparent;
  padding: ${space('sm')} 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  appearance: none;
  border-width: 0 0 3px 0;
  border-style: solid;
  border-color: ${({ $active }) => ($active ? color('cta') : 'transparent')};
  cursor: ${({ $active }) => ($active ? 'default' : 'pointer')};
  transition:
    border-color 0.3s ease-in-out,
    color 0.3s ease-in-out;

  @media screen and (${query.below('tablet')}) {
    ${font('subhead-xs')};
    line-height: 1.05;
  }

  &:hover {
    border-color: ${({ $active }) => ($active ? color('cta') : color('gray2'))};
    color: ${({ $active }) => ($active ? color('fg') : color('gray5'))};
  }
`;

export const GalleryModalCloseButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: ${space('x5')};
  background-color: transparent;
  margin: 0;
  padding: 0;
  cursor: pointer;
  outline: none;
  appearance: none;
  border: none;
  transition: color 0.3s ease-in-out;
  z-index: 100;

  @media screen and (${query.below('tablet')}) {
    transform: none;
    top: ${space('xl')};
  }

  &:hover {
    color: ${color('gray4')};
  }

  svg {
    display: block;
    width: ${space('x5')};
    height: ${space('x5')};
  }
`;

export const GalleryModalContent = styled.div`
  height: 100%;
  overflow-y: scroll;
`;

export const GalleryModalImages = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space('xl')};
  margin-top: ${space('lg')};
  margin-bottom: 4rem;

  @media screen and (${query.atLeast('tablet')}) {
    grid-template-columns: repeat(2, 1fr);
    gap: ${space('x5')};
    margin-top: 0;
  }

  @media screen and (${query.atLeast('desktop')}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const GalleryModalImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 75%; // 4:3 aspect ratio

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
